module.exports = __webpack_public_path__ + "static/img/bg-en.90be3dc4.png";